// ============================================================
// content.js — INHALTE (von Layout getrennt, hier bearbeiten)
// ============================================================

export const heroContent = {
  badge: "Premium Kühlschrankmagnete",
  titleLine1: "Deine Momente",
  titleLine2: "Als Fotomagnete",
  titleLine3: "Selbst gestalten",
  description:
    "Deine Fotos als hochwertige Kühlschrankmagnete mit Metallkern. Individuell für dich in Deutschland gefertigt, hochwertig im Druck und in 3–5 Werktagen bei dir.",
  ctaLabel: "Jetzt Fotomagnete gestalten",
  note: "JPEG, PNG & HEIC · kein Konto nötig",
  formatNote: "Format: 78 × 53 mm",
};

// Nur die 6 neu hochgeladenen Kundenfotos - keine alten Assets
export const heroMagnets = [
  { id: "magnet-1", rotate: "-2deg", src: "/assets/magnet-wedding.png", alt: "Kühlschrankmagnet mit eigenem Hochzeitsfoto" },
  { id: "magnet-2", rotate: "2deg", src: "/assets/magnet-dog.png", alt: "Kühlschrankmagnet mit eigenem Hundefoto" },
  { id: "magnet-3", rotate: "2deg", src: "/assets/magnet-friends.png", alt: "Kühlschrankmagnet mit eigenem Freundinnen-Foto" },
  { id: "magnet-4", rotate: "-2deg", src: "/assets/magnet-france-flag.png", alt: "Kühlschrankmagnet mit eigenem Motiv Frankreich-Flagge" },
  { id: "magnet-5", rotate: "-2deg", src: "/assets/magnet-horse.png", alt: "Kühlschrankmagnet mit eigenem Foto von Reiterin und Pferd" },
  { id: "magnet-6", rotate: "2deg", src: "/assets/magnet-cat.png", alt: "Kühlschrankmagnet mit eigenem Katzenfoto" },
];

export const trustBar = [
  { icon: "shield", label: "Sicher bezahlen" },
  { icon: "truck", label: "Versand in 3–5 Tagen" },
  { icon: "image", label: "Brillanter Premium-Fotodruck" },
  { icon: "check", label: "Qualitätsgarantie" },
];

export const packages = [
  { size: 3, price: "11,95 €", per: "3,98 € pro Magnet", label: "Mini", badge: null },
  { size: 6, price: "19,95 €", per: "3,32 € pro Magnet", label: "Starter", badge: null },
  { size: 9, price: "27,95 €", per: "3,11 € pro Magnet", label: "Familie", badge: null },
  { size: 12, price: "34,90 €", per: "2,91 € pro Magnet", label: "Spar-Paket", badge: "★ Bestseller" },
];

export const packageFeatures = (size) => [
  `${size} individuelle Motive`,
  "Premium-Fotodruck auf Fotopapier",
  "Versand 4,90 €",
];

export const paymentNote =
  "Alle Preise inkl. MwSt., zzgl. 4,90 € Versand · Sichere Zahlung mit PayPal (auch mit Kreditkarte) oder Überweisung · Lieferung nur innerhalb Deutschlands";
export const bulkCta = "Größere Stückzahlen auf Anfrage";

export const steps = [
  { n: "01", title: "Fotos hochladen", text: "Wähle deine Lieblingsbilder – JPEG, PNG oder direkt vom iPhone (HEIC)." },
  { n: "02", title: "Wir drucken", text: "Professioneller, randloser Premium-Fotodruck mit schützender Deckfolie." },
  { n: "03", title: "Freude schenken", text: "In 3–5 Werktagen bei dir – ab an den Kühlschrank." },
];

export const qualityIntro = {
  eyebrow: "Qualität",
  title: "Premium in jedem Detail",
  description:
    "Jeder Fotomagnet wird individuell für dich gefertigt: mit stabilem Metallkern, hochwertigem Fotopapier und schützender Versiegelung. So entsteht ein langlebiger Magnet mit kräftigen Farben und abwischbarer Oberfläche.",
};

export const layerLabels = [
  { title: "Versiegelung", text: "Abwischbare Schutzschicht." },
  { title: "Premium-Fotodruck", text: "Brillante, langlebige Farbwiedergabe." },
  { title: "Stabiler Metallkern", text: "Starke, zuverlässige Haftkraft." },
  { title: "Rückenplatte mit Magnet", text: "Stabiler, formstarker Kunststoffträger." },
  { title: "Format", text: "78 × 53 mm" },
];

// Neu hochgeladenes Foto (Hund) für die 1:1-Originalgröße-Darstellung
export const trueScaleImage = "/assets/magnet-dog.png";

export const faqItems = [
  { question: "Welche Fotos kann ich hochladen?", answer: "Alle gängigen Formate: JPEG, PNG und HEIC direkt vom iPhone. Am besten möglichst scharfe Bilder mit guter Auflösung – wir passen sie automatisch auf das Magnetformat an." },
  { question: "Wie lange dauert der Versand?", answer: "Nach deiner Bestellung produzieren und versenden wir innerhalb von 3–5 Werktagen. Du erhältst eine Bestätigung per E-Mail. Aktuell liefern wir nur innerhalb Deutschlands." },
  { question: "Wie haften die Magnete?", answer: "Jeder Magnet hat einen starken Metallrücken und hält zuverlässig an Kühlschrank, Whiteboard oder jeder magnetischen Fläche." },
  { question: "Kann ich umtauschen oder zurückgeben?", answer: "Da deine Magnete individuell mit deinen Fotos bedruckt und eigens für dich angefertigt werden, besteht kein gesetzliches Widerrufsrecht – eine Rückgabe oder ein Umtausch aus Geschmacksgründen ist daher nicht möglich. Sollte aber mit dem Druck oder der Qualität etwas nicht stimmen, ersetzen wir das selbstverständlich kostenlos." },
  { question: "Wie kann ich bezahlen?", answer: "Du kannst per PayPal (auch mit Kreditkarte) oder per Überweisung bezahlen." },
];

export const defaultSeo = {
  title: "Premium Kühlschrankmagnete mit Foto selbst gestalten | magnetixs",
  description: "Premium Kühlschrankmagnete mit Foto selbst gestalten. Metallkern, hochwertiger Druck, 3-5 Tage Lieferung. Jetzt gestalten!",
};

export const inspirationItems = [
  {
    slug: "hund-haustiere",
    title: "Hund & Haustiere",
    text: "Ob verspielter Welpe, würdevolle Katze oder dein treues Pferd: Mit einem Kühlschrankmagnet hältst du die Persönlichkeit deines Tieres dauerhaft fest. Aus deinem Lieblingsfoto entsteht ein individueller Fotomagnet, der jeden Tag ein kleines Lächeln schenkt – ein wunderschönes Erinnerungsstück für Tierliebhaber und ein persönliches Geschenk für jeden Haustierfreund.",
    seoTitle: "Kühlschrankmagnete für Hund, Katze & Pferd gestalten | magnetixs",
    seoDescription: "Verewige deinen Hund, deine Katze oder dein Pferd als hochwertigen Kühlschrankmagnet mit Metallkern. Individuell für dich in Deutschland gefertigt, Lieferung in 3-5 Werktagen.",
  },
  {
    slug: "auto-motorrad",
    title: "Auto & Motorrad",
    text: "Dein Auto ist dein ganzer Stolz? Dann bring es vom Asphalt direkt an den Kühlschrank. Ob dein tägliches Tracktool, dein edler Oldtimer oder dein Motorrad – wir verwandeln dein Fahrzeugfoto in hochwertige Kühlschrankmagnete aus Metall. Gestochen scharfe Details machen dein Bild zum Sammlerstück.",
    seoTitle: "Kühlschrankmagnete für Auto & Motorrad gestalten | magnetixs",
    seoDescription: "Oldtimer, Tracktool oder Motorrad: Verwandle dein Fahrzeugfoto in einen edlen Kühlschrankmagnet aus Metall. Premium-Fotodruck, individuell für dich in Deutschland gefertigt.",
  },
  {
    slug: "wohnmobil-camping",
    title: "Wohnmobil & Camping",
    text: "Halte die Freiheit deines Roadtrips fest. Unsere individuellen Kühlschrankmagnete von deinem Camper oder Wohnmobil erinnern dich jeden Tag an die schönsten Stellplätze. Robust und abwischbar – der ideale Metallmagnet, um deine Camping-Erinnerungen für immer zu bewahren.",
    seoTitle: "Kühlschrankmagnete für Wohnmobil & Camping gestalten | magnetixs",
    seoDescription: "Halte deine Roadtrip-Erinnerungen mit einem individuellen Kühlschrankmagnet von Camper oder Wohnwagen fest. Robust, abwischbar, individuell für dich in Deutschland gefertigt.",
  },
  {
    slug: "hochzeit-liebe",
    title: "Hochzeit & Liebe",
    text: "Die schönsten Momente eures Lebens verdienen einen besonderen Platz. Gestalte personalisierte Kühlschrankmagnete als edle Gastgeschenke zur Hochzeit oder als Save-the-Date. Ein haptischer Fotomagnet mit Metallkern, der eure Liebe hochwertig in Szene setzt.",
    seoTitle: "Kühlschrankmagnete zur Hochzeit als Gastgeschenk | magnetixs",
    seoDescription: "Personalisierte Kühlschrankmagnete als edles Gastgeschenk oder Save-the-Date. Fotomagnet mit Metallkern, individuell für dich in Deutschland gefertigt, in 3-5 Werktagen.",
  },
  {
    slug: "baby-familie",
    title: "Baby & Familie",
    text: "Die ersten Augenblicke vergehen so schnell – halte sie auf Premium-Kühlschrankmagneten fest. Ob Babyfotos zur Geburt oder das schönste Familienfoto zu Weihnachten. Unsere Fotomagnete sind ein herzliches Geschenk mit Metallkern für Mama, Papa, Oma und Opa.",
    seoTitle: "Kühlschrankmagnete für Baby & Familie gestalten | magnetixs",
    seoDescription: "Halte die ersten Augenblicke auf einem Premium-Kühlschrankmagnet fest – ein herzliches Geschenk für Mama, Papa, Oma und Opa. Individuell für dich in Deutschland gefertigt.",
  },
  {
    slug: "urlaub-reisen",
    title: "Urlaub & Reisen",
    text: "Bring das Urlaubsgefühl in deine Küche. Vom Traumstrand bis zum Städtetrip: Ein Kühlschrankmagnet mit deinem Urlaubsfoto lässt dich den Moment immer wieder erleben. Hochwertig foliert und brillant im Druck – deine Reiseerinnerungen als edle Metallmagnete.",
    seoTitle: "Kühlschrankmagnete für Urlaub & Reisen gestalten | magnetixs",
    seoDescription: "Bring dein Urlaubsgefühl in die Küche: Kühlschrankmagnet mit Foto vom Traumstrand oder Städtetrip. Brillanter Druck, individuell für dich in Deutschland gefertigt.",
  },
  {
    slug: "besondere-anlaesse",
    title: "Besondere Anlässe",
    text: "Es gibt immer einen Grund zum Schenken. Ob zum Geburtstag, zur Taufe oder als Aufmerksamkeit: Individuelle Kühlschrankmagnete sind eine originelle Geschenkidee. Jeder Fotomagnet besticht durch seinen massiven Metallkern und lange Haltbarkeit.",
    seoTitle: "Kühlschrankmagnete zu besonderen Anlässen gestalten | magnetixs",
    seoDescription: "Individuelle Kühlschrankmagnete als originelle Geschenkidee zum Geburtstag, zur Taufe oder als Aufmerksamkeit. Massiver Metallkern, individuell für dich in Deutschland gefertigt.",
  },
];

export const contactEmail = "info@magnetixs.de";
export const footerLinks = [
  { label: "Impressum", to: "/impressum" },
  { label: "Datenschutz", to: "/datenschutz" },
  { label: "AGB", to: "/agb" },
  { label: "Widerruf", to: "/widerruf" },
];

// IT-Recht Kanzlei Code-Snippets (data-itrk-legaltext-url) - alle 4 Rechtstexte final zugeordnet
// und via Testroute inhaltlich verifiziert (27.08.2026).
export const legalSnippets = {
  impressum: "https://itrk.legal/1yez.0.1baX-de-iframe.html",
  datenschutz: "https://itrk.legal/1yez.8U.1baX-iframe.html",
  agb: "https://itrk.legal/1yez.2Y.1baX-iframe.html",
  widerruf: "https://itrk.legal/1yez.2J.1baX-iframe.html",
};

// Bildschirmdiagonale in Zoll - gängige Geräte zur Originalgröße-Berechnung
export const screenSizeOptions = [
  { label: "Windows-Laptop 15,6\"", inches: 15.6 },
  { label: "Windows-Laptop 14\"", inches: 14.0 },
  { label: "MacBook Air/Pro 13\"", inches: 13.3 },
  { label: "MacBook Pro 14\"/16\"", inches: 15.0 },
  { label: "Monitor 24\"", inches: 24.0 },
  { label: "Monitor 27\"", inches: 27.0 },
  { label: "iPad / Tablet 10,9\"", inches: 10.9 },
  { label: "iPhone (Standard, 6,1\")", inches: 6.1 },
  { label: "iPhone Plus/Pro Max (6,7\")", inches: 6.7 },
  { label: "Android-Smartphone 6,5\"", inches: 6.5 },
];

